import { VENTAS } from '../actions/types';

const initialState = {
    clientesBusqueda: [],
    clienteCreado: null,
    metodos: [],
    productosBusqueda: [],
    categoriasVenta: [],
    subcategoriasVenta: [],
    productosInventario: [],
    detalleProducto: null,
    ventaCreada: null,
    listadoVentas: [],
    loadingListadoVentas: false,
    detallesVenta: null,
    loadingDetallesVenta: false,
    ventaEdicion: null,
    ventaEditada: null,
    devolucionesVenta: [],
};

export default function ventasReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case VENTAS.CLIENTES_BUSCAR:
            return {
                ...state,
                clientesBusqueda: Array.isArray(payload) ? payload : []
            };

        case VENTAS.CLIENTES_LIMPIAR:
            return {
                ...state,
                clientesBusqueda: []
            };

        case VENTAS.CLIENTE_CREADO:
            return {
                ...state,
                clienteCreado: payload || null
            };

        case VENTAS.METODOS_LISTAR:
            return {
                ...state,
                metodos: Array.isArray(payload) ? payload : []
            };

        case VENTAS.PRODUCTOS_LISTAR:
            return {
                ...state,
                productosBusqueda: Array.isArray(payload) ? payload : []
            };

        case VENTAS.PRODUCTOS_LIMPIAR:
            return {
                ...state,
                productosBusqueda: []
            };

        case VENTAS.CATEGORIAS_CARGADAS:
            return {
                ...state,
                categoriasVenta: Array.isArray(payload) ? payload : []
            };

        case VENTAS.SUBCATEGORIAS_CARGADAS:
            return {
                ...state,
                subcategoriasVenta: Array.isArray(payload) ? payload : []
            };

        case VENTAS.INVENTARIO_PRODUCTOS_LISTAR:
            return {
                ...state,
                productosInventario: Array.isArray(payload) ? payload : []
            };

        case VENTAS.INVENTARIO_PRODUCTOS_LIMPIAR:
            return {
                ...state,
                productosInventario: []
            };

        case VENTAS.DETALLE_PRODUCTO:
            return {
                ...state,
                detalleProducto: payload || null
            };

        case VENTAS.LIMPIAR_DETALLE_PRODUCTO:
            return {
                ...state,
                detalleProducto: null
            };

        case VENTAS.VENTA_CREADA:
            return {
                ...state,
                ventaCreada: payload || null
            };

        case VENTAS.LIMPIAR_VENTA:
            return {
                ...state,
                ventaCreada: null
            };

        case VENTAS.ERROR:
            return {
                ...state,
                loadingListadoVentas: false
            };

        case VENTAS.LISTAR_VENTAS_CARGANDO:
            return {
                ...state,
                loadingListadoVentas: true
            };

        case VENTAS.LISTAR_VENTAS:
            return {
                ...state,
                listadoVentas: Array.isArray(payload) ? payload : [],
                loadingListadoVentas: false
            };
        
        case VENTAS.DETALLES_VENTA_CARGANDO:
            return {
                ...state,
                detallesVenta: null,
                loadingDetallesVenta: true
            };

        case VENTAS.DETALLES_VENTA:
            return {
                ...state,
                detallesVenta: payload || null,
                loadingDetallesVenta: false
            };

        case VENTAS.LIMPIAR_DETALLES_VENTA:
            return {
                ...state,
                detallesVenta: null,
                loadingDetallesVenta: false,
                devolucionesVenta: []
            };
        
        case VENTAS.DETALLES_EDITAR:
            return {
                ...state,
                ventaEdicion: action.payload
            };

        case VENTAS.LIMPIAR_DETALLES_EDITAR:
            return {
                ...state,
                ventaEdicion: null,
                devolucionesVenta: []
            };

        case VENTAS.EDITAR_OK:
            return {
                ...state,
                ventaEditada: action.payload
            };

        case VENTAS.DEVOLUCIONES_LISTAR:
            return {
                ...state,
                devolucionesVenta: Array.isArray(payload) ? payload : []
            };

        default:
            return state;
    }
}
